import {Button, Grid, Paper, TextField} from "@mui/material";
import React, {useState} from "react";
import {IRecursoMovimentacao} from "@models/recurso/IRecursoMovimentacao.ts";
import dayjs from "dayjs";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {MoneyInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateMovimentacaoRecurso} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface CreaterecursoMovimentacaoComponentProps {
    recursoId: number,
    onCreate?: (movimentacao: IRecursoMovimentacao) => void
}

export const CreaterecursoMovimentacaoComponent: React.FC<CreaterecursoMovimentacaoComponentProps> = ({
                                                                                                          recursoId,
                                                                                                          onCreate
                                                                                                      }) => {
    const {Get} = useApi()
    const {createAlertFromResponse} = useAlert()

    const [movimentacao, setMovimentacao] = useState<IRecursoMovimentacao>({
        recursoId: recursoId,
        valorEfetivo: 0,
        valorPendente: 0,
        dataMovimentacao: dayjs(),
        id: 0,
        motivo: "",
        tipoMovimentacaoId: 1,
        usuarioCriacaoId: 0,
        dataCriacao: dayjs(),
        valorCancelado: 0,
        status: "Pendente"
    });

    const createMovimentacaoHandler = () => {
        Get(CreateMovimentacaoRecurso(movimentacao as IRecursoMovimentacao)).then(x => {
            createAlertFromResponse(x)

            if (x.status == 'Success') {

                setMovimentacao({
                    ...movimentacao,
                    valorEfetivo: 0,
                    valorPendente: 0,
                    dataMovimentacao: dayjs(),
                    id: 0,
                    motivo: "",
                    tipoMovimentacaoId: 1,
                    usuarioCriacaoId: 0,
                })
                if (onCreate) {
                    onCreate(x.items)
                }
            }
        })
    }

    return (
        <DefaultContainer component={Paper}>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <TextField fullWidth label={'Descreva o motivo da transferencia'} value={movimentacao.motivo}
                               onChange={(e) => {
                                   setMovimentacao({
                                       ...movimentacao,
                                       motivo: e.target.value
                                   })
                               }}
                    />
                </Grid>
                <Grid size={12}>
                    <MoneyInputEntry onChange={(v) => setMovimentacao({...movimentacao, valorEfetivo: v ?? 0})}
                                     value={movimentacao.valorEfetivo}
                                     label={'Valor da movimentação'}
                    />
                </Grid>
                <Grid size={12}>
                    <Button fullWidth variant={'outlined'} onClick={createMovimentacaoHandler}>
                        Criar movimentação
                    </Button>
                </Grid>
            </Grid>

        </DefaultContainer>
    )
}